import Overview from '@rebuild/materials/shared/announcement/OverviewIndex.vue';
import Full from '@rebuild/materials/shared/announcement/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 